import request from '@/utils/http.js';
import axios from "axios";
import qs from 'qs';
// 查询自然语言语句的解析信息
let fn = () => {}
export function getLanguageForStock(options) {
    fn()
    return request({
      url: `${window.config.api_v1}/custom/getLanguageForStock`,
      method: 'GET',
      params: options,
      type: "json",
      cancelToken: new axios.CancelToken(canceIFn => {
        // canceLFn: 取消当前这个接口请求方法
        fn = canceIFn
      })
    });
  }

// 获取用户的自然语言收藏
export function issueList(params = {}) {
	return request({
		url: `${window.config.api_v6}/Huis/issueList`,
		method: "get",
		params,
		type: "json",
	});
}

//添加自然语言因子
export function addNatureLanguage(options) {
    return request({
      url: `${window.config.api_v1}/custom/addNatureLanguage`,
      method: "post",
      data: qs.stringify(options),
    });
  }

// 根据 ID 查询自定义因子详情  getCustomFactorById
export function getCustomFactorById(params = {}) {
	return request({
		url: `${window.config.api_v1}/custom/getCustomFactorById`,
		method: "get",
		params,
		type: "json",
	});
}

// 查询避险热门策略(产品1)
export function getStrategy(params = {}) {
	return request({
		url: `${window.config.api_v1}/hedging/getStrategy`,
		method: "get",
		params,
		type: "json",
	});
}
